import React, { Component } from 'react';
import './Guides.css';

import { Nav, Navbar, NavItem, NavLink, NavbarToggler, NavbarBrand, Collapse } from 'reactstrap';
import { Link } from 'gatsby';

import MultiImageHeader from '../elements/MultiImageHeader';
import TopIcon from '../elements/TopIcon';
import RenderEssentials from '../elements/render/RenderEssentials';
import RenderHighlights from '../elements/render/RenderHighlights';
import RenderCard from '../elements/render/RenderCard';

import CountryMetadata from '../../metadata/CountryMetadata';

class CountryGuide extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isNavOpen: false
        }

        this.toggleNav = this.toggleNav.bind(this);
        this.closeNav = this.closeNav.bind(this);

        this.topRef= React.createRef();
        this.essentialsRef = React.createRef();
        this.travelGuideRef = React.createRef();
        this.destinationsRef = React.createRef();
        this.itineraryRef = React.createRef();
        this.survivalRef = React.createRef();
    }

    toggleNav() {
        this.setState({ isNavOpen: !this.state.isNavOpen});
    }

    closeNav() {
        this.setState({ isNavOpen: false });
    }

    render() {
        const RenderTravelGuides = ({ guides }) => guides.map((guide, key) => {
            return (
                <div key={ key }>
                    <div className="col-12 col-lg-11 ms-auto me-auto" >
                        <div className="row" style={{ marginTop: '40px', marginBottom: '20px' }}>
                            <h4>{ guide.title }</h4>
                        </div>
                    </div>
                    <div className="row">
                        <RenderCard data={ guide.places } pathname={ this.props.pathname } />
                    </div>
                </div>
            );
        });

        const RenderSurvival = ({ guides }) => guides.map((guide, key) => {
            return(
                <RenderEssentials title={ guide.title } text={ guide.description } />
            )
        });

        const RenderItinerary = ({ itineraries }) => itineraries.map((itinerary, key) => {
            return (
                <React.Fragment>
                    <div style={{ marginBottom: '50px' }}>
                        <h4>{ itinerary.name }</h4>
                        { itinerary.description }
                    </div>
                </React.Fragment>
            );
        })

        const RenderDestinations = ({ destinations }) => destinations.map((destination, key) => {
            return (
                <div key={ key }>
                    <div className="col-12 col-lg-11 ms-auto me-auto" >
                        <div className="row" style={{ marginTop: '40px', marginBottom: '20px' }}>
                            <h4>{ destination.title }</h4>
                        </div>
                        { destination.description }
                    </div>
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-12 col-lg-11 ms-auto me-auto">
                            <RenderHighlights highlights={ destination.places } />
                        </div>
                    </div>
                </div>
            );
        });

        return(
            <React.Fragment>
                <CountryMetadata image={ this.props.country.images[0] } title={ this.props.country.name } description={ this.props.country.description }
                    pathname={ this.props.pathname } />
                <div id="page-top" ref={ this.topRef } className='header-topic'>
                    <TopIcon />
                    <MultiImageHeader images={ this.props.country.images } name={ this.props.country.name } thumb={ this.props.country.thumb } />
                    <div className="header-text">
                        <p>{ this.props.country.continent }</p>
                        <h1 className="header-title">{ this.props.country.name }</h1>
                        <p className="header-caption">{ this.props.country.caption }</p>
                    </div>
                </div>

                <Navbar light sticky="top" className="bg-light border" expand="md">
                    <div className="container">
                        <NavbarBrand className="d-block d-md-none" href="" onClick={() => {
                                this.topRef.current.scrollIntoView();
                                this.closeNav(); }}>
                            { this.props.country.name }
                        </NavbarBrand>
                        <NavbarToggler onClick={ this.toggleNav } />
                        <Collapse isOpen={ this.state.isNavOpen } navbar >
                            <Nav navbar>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.essentialsRef.current.scrollIntoView();
                                            this.closeNav(); }}>Essentials</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.travelGuideRef.current.scrollIntoView();
                                            this.closeNav(); }}>Travel Guides</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.destinationsRef.current.scrollIntoView();
                                            this.closeNav(); }}>Destinations</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.itineraryRef.current.scrollIntoView();
                                            this.closeNav(); }}>Itinerary</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                             this.survivalRef.current.scrollIntoView();
                                             this.closeNav(); }}>Survival Guide</NavLink>
                                </NavItem>
                            </Nav>
                            <Nav className="ms-auto" navbar>
                                <NavItem>
                                    <NavLink tag={ Link } to={ this.props.urlBack }>{ this.props.country.continent }</NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>

                <div className="container">
                    <div className="city-header">
                        <h1>{ this.props.country.name } Travel Guide</h1>
                        <div className="col-12 col-sm-10 m-auto">
                            { this.props.country.description }
                        </div>
                    </div>

                    <div className="city-text">
                        <div className="city-topic">
                            <div className="col-12 col-lg-11 ms-auto me-auto" >
                                <h1 id="essentials" ref={ this.essentialsRef }>Essentials</h1>
                                <RenderEssentials title={`How many days in ${this.props.country.name}?`} text={this.props.country.nrDays} />
                                <RenderEssentials title={`When To Visit ${this.props.country.name}?`} text={this.props.country.whenVisit} />
                                <RenderEssentials title={`How To Get Around ${this.props.country.name}?`} text={this.props.country.mobility} />
                                <RenderEssentials title={`Culture and Comunication in ${this.props.country.name}`} text={this.props.country.culture} />
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-11 ms-auto me-auto" >
                                <h1 id="travelGuide" ref={ this.travelGuideRef }>Travel Guides</h1>
                            </div>
                            <RenderTravelGuides guides={ this.props.country.guides } />
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-11 ms-auto me-auto" >
                                <h1 id="destinations" ref={ this.destinationsRef }>Destinations</h1>
                            </div>
                            <RenderDestinations destinations={ this.props.country.destinations } />
                        </div>


                        <div className="city-topic">
                            <div className="col-12 col-lg-11 ms-auto me-auto">
                                <h1 id="itinerary" ref={ this.itineraryRef }>Itinerary</h1>
                                <RenderItinerary itineraries={ this.props.country.itineraries } />
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-11 ms-auto me-auto" >
                                <h1 id="survival" ref={ this.survivalRef }>Survival Guide</h1>
                                <RenderSurvival guides={ this.props.country.survival } />
                            </div>
                        </div>

                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default CountryGuide;
